import apiService from "../../service/apiService";
import newcustomer from "@/constants/newcustomer";
import {cloneDeep} from "lodash";
import moment from "moment/moment";

export default {
    namespaced: true,
    state: () => ({
        claims: [],

        claimfilters:{
            branch_id:'',
            order_id:'',
            customer_name:'',
            phone_number:'',
            status:'',



            page:1,


        }


    }),
    mutations: {



    },
    actions: {






    },
    getters: {}
}
